import { useCallback } from "react";
import { t } from "i18next"; //used this to avoid queue error
import { useDispatch, useSelector } from "react-redux";

import { updateGlobalData } from "@common/GlobalDataSlice";

import { getPopupCallback, setPopupCallback } from "./popupCallbackStore";

export const useFullScreenPopup = () => {
  const dispatch = useDispatch();
  const { fullScreenData } = useSelector(state => state.globalAppData);

  const showFullScreenPopup = useCallback(
    data => {
      const { onCloseAction, ...serializableData } = data;

      // Store the callback in our singleton store
      if (typeof onCloseAction === "function") {
        setPopupCallback(onCloseAction);
      }

      serializableData.confirmBtn = serializableData.confirmBtn || t("okay");
      dispatch(updateGlobalData({ type: "fullScreenData", value: serializableData }));
    },
    [dispatch],
  );

  const hideFullScreenPopup = useCallback(
    (actionType, data) => {
      // Get and execute callback from singleton store
      const callback = getPopupCallback();
      if (typeof callback === "function") {
        callback(actionType, data);
      }
      dispatch(updateGlobalData({ type: "fullScreenData", value: null }));
    },
    [dispatch],
  );

  return { fullScreenData, showFullScreenPopup, hideFullScreenPopup };
};
